export const usePlayerPreloader = () => {
  // disable preloading on web
};
